import { createSelector } from 'reselect'
import mediaTypes from 'helpers/enums/mediaTypes'

const getAssets = state => state.assets

export default createSelector(
	[ getAssets ],
	assets => (assetId, assetType) => getAssetById(assets, assetId, assetType)
)

const getAssetById = (assets, assetId, assetType) => {
	let asset
	switch (assetType) {
		case mediaTypes.VIDEO:
			asset = assets.videos[assetId]
			break
		case mediaTypes.IMAGE:
			asset = assets.images[assetId]
			break
		case mediaTypes.BINARY:
			asset = assets.binaries[assetId]
			break
		default:
			break
	}

	return asset
}
